<template>
  <div class="create-batch-check-order-job">
    <a-spin :spinning="loading">
      <div class="content flex-ct between" style="min-height: 0">
        <a-tabs default-active-key="OrderStatusFlow" @change="changeTabs">
          <a-tab-pane key="BaseInfo" :tab="$t(`基本信息`)"></a-tab-pane>
          <a-tab-pane key="AmountInfo" :tab="$t(`金额信息`)"></a-tab-pane>
          <a-tab-pane key="ProductInfo" :tab="$t(`付款计划`)"></a-tab-pane>
        </a-tabs>
        <div class="flex-ct" v-show="!loading">
          <OperateBtn
            v-if="$store.getters.hasFunction('payable_review') && formData.status === 'WAIT_CHECK'"
            api="operateDoc"
            :text="$t('审核')"
            :params="{
              action: 'check',
              docType,
              idList: [id],
            }"
            @success="init"
          />
          <PushBtn
            v-if="formData.status === 'WAIT_PAY' || formData.status === 'PART_PAID'"
            class="ml10"
            :docType="docType"
            :selectedRows="[formData]"
          />
          <FindRelatedDocBtn class="ml10" :id="id" :docType="docType" v-if="isDetail" />
          <OperateBtn
            v-if="isDetail && ['DRAFT', 'WAIT_CHECK', 'WAIT_PAY'].includes(formData.status)"
            class="ml10"
            api="cancelDepositPayment"
            :text="$t('作废')"
            type="danger"
            :params="{
              idList: [id],
            }"
            @success="init"
          />
          <VoucherBtn
            class="ml10"
            v-if="
              isDetail &&
              !['DRAFT', 'WAIT_CHECK', 'CANCELLED'].includes(formData.status) &&
              !formData.voucherGenerated
            "
            :docType="docType"
            :selectedRows="[formData]"
            @close="init"
          />
        </div>
      </div>
      <div class="content-overflow">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData">
            <ModalBox
              id="BaseInfo"
              :title="$t('基本信息')"
              :showCopy="isDetail"
              @copyOrder="copyOrder"
            >
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`预付单号`)">
                    <a-input disabled v-model="formData.orderSn"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`申请时间`)">
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.applyTime"
                      @choose="chooseOrderDate"
                      :disabled="isDisabled"
                      :placehold="$t(`申请时间`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`单据类型`)" required>
                    <SelectDocumentType
                      :docType="docType"
                      :code.sync="formData.orderType"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`结算组织`)" required>
                    <CommonSelect
                      :isBu="true"
                      :list="$store.state.settlementBuList"
                      :disabled="isDisabled"
                      :code.sync="formData.businessUnitCode"
                      :name.sync="formData.businessUnitName"
                      @change="changeBU"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <CommonPayeeSelect
                    :orderType="formData.orderType"
                    :type.sync="formData.payeeType"
                    :code.sync="formData.payeeCode"
                    :name.sync="formData.payeeName"
                    :disabled="isDisabled"
                    :businessUnitCode="formData.businessUnitCode"
                  />
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`业务单号`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.bizOrderSn"
                      :placeholder="$t(`业务单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`预到货通知单号`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.asnOrderSn"
                      :placeholder="$t(`预到货通知单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`入库单号`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.receivedOrderSn"
                      :placeholder="$t(`入库单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`备注`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.remark"
                      :placeholder="$t(`备注`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t(`是否生成凭证`)">
                    <a-input
                      disabled
                      :value="+formData.voucherGenerated ? $t('是') : $t('否')"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t(`状态`)">
                    <a-input
                      disabled
                      v-model="depositPaymentStatusMapping[formData.status]"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="!isDetail">
                  <a-form-model-item :label="$t(`是否需要生成凭证`)" required>
                    <a-select
                      v-model="formData.needGenerateVoucher"
                      :placeholder="$t(`请选择`)"
                      style="width: 100%"
                    >
                      <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
            <ModalBox id="AmountInfo" :title="$t('金额信息')">
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`本位币`)" required>
                    <SelectCurrency :code.sync="formData.functionalCurrency" :disabled="true" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`结算货币`)" required>
                    <SelectCurrency
                      :code.sync="formData.settlementCurrency"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item required :label="$t(`总金额`)">
                    <PriceInput
                      disabled
                      :currency="formData.settlementCurrency"
                      :value="formData.amountWithoutTax"
                      :placeholder="$t(`总金额`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`税率`)" required>
                    <a-input-number
                      style="width: 100%"
                      :disabled="isDisabled"
                      v-model="formData.taxRate"
                      :placeholder="$t(`税率`)"
                      @blur="inputVATRateFn"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`税额`)">
                    <PriceInput
                      disabled
                      :currency="formData.settlementCurrency"
                      :value="formData.taxAmount"
                      :placeholder="$t(`税额`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`价税合计`)">
                    <PriceInput
                      :currency="formData.settlementCurrency"
                      :disabled="isDisabled"
                      :value.sync="formData.payableAmount"
                      :placeholder="$t(`价税合计`)"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
          </a-form-model>
          <ModalBox id="ProductInfo" :title="$t('付款计划')">
            <template v-slot:header>
              <div class="table-header flex-ct between pb10">
                <div></div>
                <div class="option-btns pr20" v-if="!isDisabled">
                  <span class="text-link fz16" @click="addPaymentPlan({})">
                    {{ $t('增行') }}
                  </span>
                  <span class="text-link fz16 ml10" @click="deletePaymentPlan">
                    {{ $t('删行') }}
                  </span>
                </div>
              </div>
            </template>
            <CommonTable
              :columns="paymentPlanColumns"
              :dataSource="showplanList"
              :showSelect="!isDisabled"
              :showPagination="false"
              :showSetting="false"
              :selectedRowKeys.sync="selectedRowKeys"
            >
              <template v-slot:amountWithoutTax="{ record }">
                <PriceInput
                  :value.sync="record.amountWithoutTax"
                  :disabled="isDisabled"
                  :placeholder="$t('请输入')"
                  @blur="setTotalAmount"
                />
              </template>
              <template v-slot:payableAmount="{ record }">
                <PriceInput
                  :value.sync="record.payableAmount"
                  :disabled="isDisabled"
                  :placeholder="$t('请输入')"
                  @blur="setTotalAmountByPayable(record)"
                />
              </template>
            </CommonTable>
          </ModalBox>
        </section>
        <OperationLog
          ref="OperationLogRef"
          :scrollHeight="scrollHeight"
          :actionSn="sn"
          :type="docType"
          v-if="isDetail"
        />
      </div>

      <BottomBtns
        :isEdit.sync="isEdit"
        :isDetail="isDetail"
        :draftLoading="draftLoading"
        :saveLoading="saveLoading"
        :status="formData.status"
        @submit="onSubmit"
        @cancel="getDetailInfo"
        @back="backForm"
      />
    </a-spin>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import SelectCurrency from '@component/selectCurrency'
import CommonSelect from '@component/commonSelect'
import CommonPayeeSelect from '@component/commonPayeeSelect'
import { add, divide, multiply, subtract } from '@/common/number'
import DatePicker from '@component/datePicker'
import CommonTable from '@component/commonTable'
import PushBtn from '@component/pushBtn'
import VoucherBtn from '@component/voucherBtn'
import BottomBtns from '@component/bottomBtns'
import OperationLog from '@component/operationLog'
import formatter from '@/common/formatter'
import deepClone from '@/common/deepClone'
import { convertKeysToCamelCase, goBack } from '@/common'
import debounce from '@/common/debounce'
import SelectDocumentType from '@component/selectDocumentType'
export default {
  name: 'payableDetail',
  components: {
    DatePicker,
    SelectCurrency,
    CommonSelect,
    CommonPayeeSelect,
    BottomBtns,
    CommonTable,
    PushBtn,
    VoucherBtn,
    OperationLog,
    SelectDocumentType,
  },
  data() {
    return {
      id: '',
      sn: '',
      docType: 'DepositPayment',
      isCopy: false,
      loading: false,
      visible: false,
      isDetail: false, //是否是详情页
      isEdit: false, //是否是详情页
      // 表格选中key
      selectedRowKeys: [],
      formData: {
        warehouseCode: undefined,
        invoiceType: undefined,
        taxRate: 0,
        taxAmount: undefined,
        amountWithoutTax: undefined,
        payableAmount: undefined,
        settlementCurrency: 'CNY',
        payeeType: 'SUPPLIER',
        payeeCode: undefined,
        payeeName: undefined,
        status: 'DRAFT',
        needGenerateVoucher: undefined,
      },
      supplierIndex: undefined,
      draftLoading: false,
      saveLoading: false,
      planList: [],
      byPercent: true,
    }
  },
  activated() {
    this.init()
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.$data, this.$options.data())
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  computed: {
    ...mapState(['deposit_payment_type']),
    ...mapGetters(['depositPaymentStatusMapping']),
    isDisabled() {
      return this.isDetail && !this.isEdit
    },
    scrollHeight() {
      let height = window.innerHeight - 280
      return height * this.$store.state.rate + 'px'
    },
    paymentPlanColumns() {
      return [
        {
          title: this.$t('金额'),
          dataIndex: 'amountWithoutTax',
          scopedSlots: {
            customRender: 'amountWithoutTax',
          },
        },
        {
          title: this.$t('税率') + '(%)',
          dataIndex: 'taxRate',
        },
        {
          title: this.$t('税额'),
          dataIndex: 'taxAmount',
          customRender: (text) => text && Number(text),
        },
        {
          title: this.$t('价税合计'),
          dataIndex: 'payableAmount',
          scopedSlots: {
            customRender: 'payableAmount',
          },
        },
        {
          title: this.$t('已锁定金额'),
          dataIndex: 'lockAmount',
          customRender: (text) => this.showPrice(text),
        },
        {
          title: this.$t('未锁定金额'),
          dataIndex: 'unLockAmount',
          customRender: (text, record) =>
            this.showPrice(subtract(record.payableAmount, record.lockAmount || 0)),
        },
      ]
    },
    showplanList() {
      return this.planList.filter((item) => item.showStatus !== -1)
    },
  },
  methods: {
    Formatter: formatter,
    init() {
      this.isEdit = false
      this.isCopy = false
      this.isDetail = false
      if (!this.$route.query.id) {
        Object.assign(this.$data, this.$options.data())
      } else {
        this.id = this.$route.query.id
        this.sn = this.$route.query.sn
        this.isDetail = true
        this.$nextTick(() => {
          this.$refs.OperationLogRef.queryList()
        })
      }
      this.getDetailInfo()
    },
    changeBU(value) {
      this.formData.businessUnitCode = value.code
      this.formData.businessUnitName = value.name
      this.formData.functionalCurrency = value.currency
    },
    showPrice(num) {
      if (num) {
        return this.$currencySymbol(num, this.formData.settlementCurrency)
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector('.fixContent').scrollTo(0, 2000)
      })
    },
    setTotalAmount() {
      this.calPaymentPlan()
      this.calcAllAmount()
    },
    calcAllAmount() {
      let amount = 0,
        taxAmount = 0
      this.planList.forEach((item) => {
        amount = add(amount, item.amountWithoutTax)
        taxAmount = add(taxAmount, +item.taxAmount)
      })
      this.formData.amountWithoutTax = Number(amount.toFixed(4))
      this.formData.taxAmount = Number(taxAmount.toFixed(4))

      let result = this.formData.amountWithoutTax * 1 + this.formData.taxAmount * 1
      this.formData.payableAmount = isNaN(result) ? '' : Number(result.toFixed(4))
    },
    supplierIndexChange(val) {
      if (!this.formData.businessUnitCode) {
        this.formData.businessUnitCode = val.business_unit_code
        this.formData.businessUnitName = val.business_unit_name
      }
      this.$forceUpdate()
    },
    async getDetailInfo() {
      let depositPaymentFormdata = localStorage.getItem('depositPaymentFormdata')
      if (this.id) {
        this.loading = true
        let res = await http({
          url: api.getDepositPaymentDetail,
          type: 'post',
          data: {
            id: this.id,
          },
        })
        let result = convertKeysToCamelCase(res.result)
        this.planList = result.detailList.map((item) => {
          item.isPrepay = true
          return item
        })
        let formData = result
        this.formData = formData
        if (result.status === 'DRAFT') {
          this.isEdit = true
        }
        if (this.formData.amountWithoutTax) {
          this.formData.taxRate = (
            divide(this.formData.taxAmount, this.formData.amountWithoutTax) * 100
          ).toFixed(2)
        }
        this.$forceUpdate()
        this.setTotalAmount()
      } else if (depositPaymentFormdata) {
        this.isCopy = true
        let data = JSON.parse(depositPaymentFormdata)
        this.formData = data
        this.formData.orderSn = undefined
        this.formData.id = undefined
        this.formData.status = 'DRAFT'
        this.planList = deepClone(this.formData.planList)
        delete this.formData.planList
        localStorage.removeItem('depositPaymentFormdata')
        this.setTotalAmount()
      }
      this.loading = false
    },
    chooseOrderDate(data) {
      this.formData.applyTime = data.data
    },
    // 输入增值税率
    inputVATRateFn: debounce(function () {
      this.setTotalAmount()
    }),
    backForm(back = 0) {
      goBack('depositPaymentList', back)
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    copyOrder() {
      this.formData.planList = this.planList
      let data = JSON.stringify(this.formData)
      localStorage.setItem('depositPaymentFormdata', data)
      this.$router.push('/payableManage/depositPaymentDetail')
    },
    addPaymentPlan() {
      const data = {
        taxRate: this.formData.taxRate,
        taxAmount: '',
        amountWithoutTax: '',
        payableAmount: '',
      }
      this.planList.push(data)
      this.scrollToBottom()
    },
    deletePaymentPlan() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning(this.$t(`至少选中一项`))
        return
      }
      this.planList
        .filter((item) => item.showStatus !== -1)
        .forEach((item, index) => {
          if (this.selectedRowKeys.includes(index)) {
            this.$set(item, 'showStatus', -1)
            item.payableRatio = 0
            item.payableAmount = 0
            item.amountWithoutTax = 0
            item.taxAmount = 0
          }
        })
      this.selectedRowKeys = []
    },
    chooseDueDate(record, data) {
      record.dueDate = data.data
    },
    getAmountByRatio(ratio, amount) {
      amount = amount || this.formData.payableAmount
      return (multiply(amount, ratio) / 100).toFixed(4)
    },
    calPaymentPlan() {
      this.planList.forEach((item) => {
        item.taxRate = this.formData.taxRate
        if (item.amountWithoutTax) {
          item.taxAmount = this.getAmountByRatio(item.taxRate, item.amountWithoutTax)
          item.payableAmount = Number(add(item.amountWithoutTax, item.taxAmount).toFixed(4))
        }
      })
    },
    // 用户填写价税合计时，反向计算未税金额和税额
    setTotalAmountByPayable(record) {
      const taxRate = this.formData.taxRate
      if (record.payableAmount && taxRate !== undefined && taxRate !== null && taxRate !== '') {
        const rate = Number(taxRate) / 100
        const amountWithoutTax = Number((record.payableAmount / (1 + rate)).toFixed(4))
        const taxAmount = Number((record.payableAmount - amountWithoutTax).toFixed(4))
        record.amountWithoutTax = amountWithoutTax
        record.taxAmount = taxAmount
      } else if (record.payableAmount) {
        // 税率为 0 时，未税金额 = 价税合计
        record.amountWithoutTax = record.payableAmount
        record.taxAmount = 0
      }
      this.calcAllAmount()
    },
    onSubmit: debounce(async function (status) {
      if (!this.formData.payeeName) {
        this.$warning({
          title: this.$t(`警告`),
          content: this.$t(`请选择往来单位`),
        })
        return
      }
      if (this.formData.taxRate === undefined || this.formData.taxRate === null) {
        this.$warning({
          title: this.$t(`警告`),
          content: this.$t(`请填写增值税税率`),
        })
        return
      }
      const data = deepClone(this.formData)
      if (this.id) {
        data.id = this.id
      }
      data.status = status
      data.detailList = this.planList.map((item, index) => {
        item.sort = index + 1
        item.payeeType = this.formData.payeeType
        item.payeeCode = this.formData.payeeCode
        item.payeeName = this.formData.payeeName
        return item
      })
      data.merchantCode = localStorage.getItem('merchantCode')
      if (status === 'DRAFT') {
        this.draftLoading = true
      } else {
        this.saveLoading = true
      }
      try {
        await http({
          url: api.createDepositPayment,
          data: {
            depositPaymentReqVO: data,
          },
          type: 'post',
          hasLoading: true,
          success: (res) => {
            if (res.success) {
              this.$message.success({
                title: this.$t(`成功`),
                content: this.$t(`保存成功`),
              })
              if (this.isDetail) {
                this.init()
              } else {
                this.backForm()
              }
            }
          },
        })
      } finally {
        this.draftLoading = false
        this.saveLoading = false
      }
    }),
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA ::v-deep .ant-modal-footer {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.inputMody {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  outline: none;
}
.inputMody::-webkit-input-placeholder {
  color: #ccc;
}
.pricing-method {
  margin-bottom: 10px;
}
</style>
